import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Card from '../components/Card'
import Carousel from '../components/Carousel'
import Video from '../components/Video'
import MediaPlayer from '../components/MediaPlayer'
import NotFound from './NotFound'

import { Row, Content } from '../components/Layout.js'

class Solution extends Component {
  componentWillMount () {
    this.props.setModal(true)
  }

  render () {
    if (!this.props.solutions || this.props.solutions.length === 0) {
      return (
        <div className='loading-modal'>
          <div className='spinner'>
            <div className='bounce1' />
            <div className='bounce2' />
            <div className='bounce3' />
          </div>
        </div>
      )
    }

    const solution = this.props.solutions.filter((solution) => solution.id === this.props.match.params.solution)[0] || null
    if (!solution) {
      this.props.setModal(false)
      return <NotFound />
    }

    return (
      <div className='modal'>
        <section>
          <Row classes={['marginBottom']}>
            <Content classes={['contentFull']}>
              <h1 dangerouslySetInnerHTML={{__html: solution.title}} />
              <h3 dangerouslySetInnerHTML={{__html: solution.subtext}} />
            </Content>
          </Row>
          <Carousel itemsToShow={1} autoplay={false}>
            {
              solution.carousel.map(function (item, index) {
                if (item.type === 'image') { return <Card full options={{image: item.url}} key={index} /> }
                if (item.type === 'video') { return <Video full video options={{video: item.url}} key={index} /> }
                if (item.type === 'vimeo') { return <MediaPlayer full video options={{video: item.url}} key={index} /> }
                return false
              })
            }
          </Carousel>
          <Row classes={['marginBottom']}>
            <Content classes={['contentFull']}>
              <p dangerouslySetInnerHTML={{__html: solution.fulltext}} />
            </Content>
          </Row>
        </section>
      </div>
    )
  }
}

Solution.propTypes = {
  setModal: PropTypes.func,
  solutions: PropTypes.array,
  match: PropTypes.object
}

export default Solution



// WEBPACK FOOTER //
// ./src/containers/Solution.js